export const idReg = /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/
export const phoneReg = /^[01]\d{10}$/
export const bankCardReg = /^[0-9]{16,19}$/

/**
 * 验证身份证
 * @param {String} id 身份证号码
 * @returns boolean
 */
export const validateId = (id) => {
  return id && idReg.test(id)
}

/**
 * 验证手机号
 * @param {String} phone 手机号码
 */
export const validatePhone = (phone) => {
  return phone && phoneReg.test(phone)
}

/**
 * 验证银行卡号码
 * @param {String} bankCard 银行卡号码
 */
export const validateBankCard = (bankCard) => {
  return bankCard && bankCardReg.test(bankCard)
}
